import { Card, CardContent } from "./ui/card";
import { Clock, CheckCircle2, Heart, Users } from "lucide-react";

/**
 * 4-card stats row: Active / Answered / Total / Groups.
 * Pure presentation — `stats` is the shape returned by /api/auth/me's stats field.
 */
export function DashboardStats({ stats }) {
  if (!stats) return null;
  const items = [
    { key: "active",   icon: Clock,         tint: "sage", value: stats.active_prayers,   label: "Active Prayers", testid: "stat-active" },
    { key: "answered", icon: CheckCircle2,  tint: "gold", value: stats.answered_prayers, label: "Answered",       testid: "stat-answered" },
    { key: "total",    icon: Heart,         tint: "sage", value: stats.total_prayers,    label: "Total Prayers",  testid: "stat-total" },
    { key: "groups",   icon: Users,         tint: "gold", value: stats.group_count,      label: "Groups",         testid: "stat-groups" },
  ];
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {items.map((it) => {
        const Icon = it.icon;
        const bg = it.tint === "sage" ? "bg-sage/10" : "bg-gold/10";
        const fg = it.tint === "sage" ? "text-sage"  : "text-gold-dark";
        return (
          <Card key={it.key} className="border-stone" data-testid={it.testid}>
            <CardContent className="p-4 flex items-center gap-3">
              <div className={`w-10 h-10 rounded-xl ${bg} flex items-center justify-center`}>
                <Icon className={`w-5 h-5 ${fg}`} />
              </div>
              <div>
                <p className="text-2xl font-semibold text-stone-dark">{it.value ?? 0}</p>
                <p className="text-xs text-stone-dark/60">{it.label}</p>
              </div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
